module.exports = __webpack_public_path__ + "static/media/received_461383899607991.fbcfd23f.jpeg";